(function () {
  const baseScrollbarSettings = {
    loop: false,
    slidesPerView: 1.3,
    spaceBetween: 16,
    speed: 400,
    allowTouchMove: true,
    mousewheel: { forceToAxis: true },
    watchSlidesProgress: true,
    breakpoints: {
      750: { slidesPerView: 3.2,
       },
      1440: { 
        slidesPerView: 4,
      },
    },
  };

  const baseSliderSettings = {
    slidesPerView: 1.3,
    spaceBetween: 16,
    speed: 500,
    allowTouchMove: true,
  };

  const initSliders = (section, layout) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");
      if (!swiperWrapper || !slides.length) return;

      const mobSlidesPerView = swiperEl.classList.contains("products-tabs__layout--visible-overflow")
        ? "auto"
        : 1;

      if (window.innerWidth > 750 ) {
        swiperEl.classList.add("swiper");

        swiperWrapper.classList.add("swiper-wrapper");
        slides.forEach((slide, index) => {
          slide.classList.add("swiper-slide");

          let coeff = slides.length > 24 ? 0.02 : slides.length > 12 ? 0.05 : 0.1;
          slide.style.setProperty("--prod-tabs-item-delay", `${index * coeff}s`);
        });
      } 

      
     

      const progressBar = swiperEl.querySelector(".swiper-scrollbar");
      const nextBtn = swiperEl.querySelector(".products-tabs__navigation-button-next");
      const prevBtn = swiperEl.querySelector(".products-tabs__navigation-button-prev");

      let finalSettings = layout === "bar"
        ? {
            ...baseScrollbarSettings,
            scrollbar: {
              el: progressBar,
              draggable: true,
              hide: false,
            },
          }
        : {
            ...baseSliderSettings,
            slidesPerView: mobSlidesPerView,
          };

      if (nextBtn && prevBtn) {
        finalSettings.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        };
      }

      new Swiper(swiperEl, finalSettings);
    });
  };

  const destroySliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");
    swiperEls.forEach((swiperEl) => {
      const swiperInstance = swiperEl.swiper;
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperInstance || !swiperWrapper || !slides.length) return;

      swiperInstance.destroy();
      swiperEl.classList.remove("swiper");
      swiperWrapper.classList.remove("swiper-wrapper");
      slides.forEach((slide) => slide.classList.remove("swiper-slide"));
    });
  };

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll(".products-tabs__tab");
    const layouts = section.querySelectorAll(".products-tabs__layout");

    tabs.forEach((tab) => {
      const toggle = (e) => {
        e.preventDefault();
        if (tab.classList.contains("active")) return;

        const tabId = tab.dataset.productsTabId;
        tabs.forEach((t) => t.classList.remove("active"));
        layouts.forEach((l) => {
          l.classList.remove("active");
          if (l.swiper) l.swiper.slideTo(0, 0);
        });

        const activeLayout = section.querySelector(`.products-tabs__layout[data-products-tab-id="${tabId}"]`);
        tab.classList.add("active");
        activeLayout?.classList.add("active");
      };

      tab.addEventListener("click", toggle);
      tab.addEventListener("keydown", (e) => e.key === "Enter" && toggle(e));
    });
  };

  const initProductsTabs = (section) => {
    if (!section?.classList.contains("products-tabs-section")) return;

    const sliderContainer = section.querySelector(".products-tabs");
    const layout = sliderContainer.dataset.layout || "grid";
    const mobileLayout = sliderContainer.dataset.layoutMobile || "column";
    let currentLayout = null;

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        const isMobile = width < 200;

        const newLayout = isMobile
          ? mobileLayout === "slider" ? "slider" : "column"
          : layout === "bar" ? "bar" : "grid";

        if (newLayout !== currentLayout) {
          currentLayout = newLayout;
          destroySliders(section);
          if (newLayout === "slider" || newLayout === "bar") {
            initSliders(section, newLayout);
          }
        }
      });
    });

    observer.observe(section);
    toggleTab(section);
  };

  const animateProductCards = (section) => {
    if (!section?.classList.contains("products-tabs-section")) return;

    const wrapper = section.querySelector(".products-tabs__inner");
    if (!wrapper || !wrapper.classList.contains("animate-on-scroll")) return;

    ScrollTrigger.create({
      trigger: wrapper,
      start: "20% bottom",
      end: "bottom top",
      onEnter: () => wrapper.classList.add("animated"),
    });
  };

  const root = document.currentScript.parentElement;
  initProductsTabs(root);
  animateProductCards(root);

  document.addEventListener("shopify:section:load", (event) => {
    initProductsTabs(event.target);
    animateProductCards(event.target);
  });
})();
